function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { validateError } from '@/services/services';
import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
//console.log(configuration)
// declare service gtw
var appApisGTW = null;
if (!configuration['visualization']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8091')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
setupInterceptors(appApisGTW);
var loginObj = function loginObj() {
  return {
    email: window.userInfo.email,
    tokenId: window.userInfo.accessToken,
    localId: window.userInfo.localId
  };
};
var CONTROLLER_NAME = '/tbl';
var DOMAIN_DATASOURCE = '/datasource';
var headers = {
  headers: {
    'Content-Type': 'application/json'
  }
};
export default {
  getDatasourcesAssignment: function getDatasourcesAssignment(data) {
    var _this = this;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/datasource/get_assignments', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getReports) Listar accesos de un usuario.';
      return validateError(err, message, function () {
        return _this.getDatasourcesAssignment(data);
      });
    });
  },
  tableauDataSourceAddUpdate: function tableauDataSourceAddUpdate(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/datasource/tableauDataSourceAddUpdate', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauDataSourceAddUpdate) Add or Update new role';
      return validateError(err, message, function () {
        appApisGTW.tableauDataSourceAddUpdate(data);
      });
    });
  },
  syncTableauDatasource: function syncTableauDatasource(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/datasource/extractTableauDatasource/', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  setDatasourcePermission: function setDatasourcePermission(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/datasource/setDatasourcePermission', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  tableauDataSourceDelete: function tableauDataSourceDelete(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/datasource/tableauDataSourceDelete', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauDataSourceDelete) Delete role';
      return validateError(err, message, function () {
        appApisGTW.tableauDataSourceDelete(data);
      });
    });
  },
  tableauDataSourceQuery: function tableauDataSourceQuery(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/datasource/tableauDataSourceQuery', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauDataSourceQuery) Search driver connection';
      return validateError(err, message, function () {
        appApisGTW.tableauDataSourceQuery(data);
      });
    });
  },
  tableauDatasourceGet: function tableauDatasourceGet(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/datasource/tableauDatasourceGet', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauDatasourceGet) Search driver connection';
      return validateError(err, message, function () {
        appApisGTW.tableauDatasourceGet(data);
      });
    });
  },
  tableauDataSourceQueryAllDomain: function tableauDataSourceQueryAllDomain(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/datasource/tableauDataSourceQueryAllDomain', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauDataSourceQueryAllDomain) Search driver connection';
      return validateError(err, message, function () {
        appApisGTW.tableauDataSourceQueryAllDomain(data);
      });
    });
  },
  tableauDataSourceLogQuery: function tableauDataSourceLogQuery(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/datasource/tableauDataSourceLogQuery', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauDataSourceLogQuery) Search driver connection';
      return validateError(err, message, function () {
        appApisGTW.tableauDataSourceLogQuery(data);
      });
    });
  },
  tableauDataSourceInitWorkFlow: function tableauDataSourceInitWorkFlow(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/datasource/tableauDataSourceInitWorkFlow', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauDataSourceInitWorkFlow) Search driver connection';
      return validateError(err, message, function () {
        appApisGTW.tableauDataSourceInitWorkFlow(data);
      });
    });
  },
  tableauTemporalDataOperator: function tableauTemporalDataOperator(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/datasource/tableauTemporalDataOperator', body).then(function (res) {
      // return res && res.data || {}
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauTemporalDataOperator) Search driver connection';
      return validateError(err, message, function () {
        appApisGTW.tableauTemporalDataOperator(data);
      });
    });
  },
  tableauDataSourcePendingApproval: function tableauDataSourcePendingApproval(typeFlow) {
    var email = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var domain = arguments.length > 2 ? arguments[2] : undefined;
    var login = loginObj();
    email = email || window.userInfo.email;
    email = email.toLowerCase();
    var body = {
      email: email,
      typeFlow: typeFlow,
      login: login,
      domain: domain
    };
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/datasource/tableauDataSourcePendingApproval', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(listPendingApproval) getting aproval flow list';
      return validateError(err, message, function () {
        appApisGTW.tableauDataSourcePendingApproval(typeFlow);
      });
    });
  },
  tableauDataSourceSendAssignment: function tableauDataSourceSendAssignment(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/datasource/tableauDataSourceSendAssignment', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauDataSourceSendAssignment) getting aproval flow list';
      return validateError(err, message, function () {
        appApisGTW.tableauDataSourceSendAssignment(data);
      });
    });
  },
  massiveApprove: function massiveApprove() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_DATASOURCE, "/massive_approve"), body).then(function (response) {
      return response.data;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  bulkLoad: function bulkLoad() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_DATASOURCE, "/bulk_load"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  }
};